import React from 'react';
import './BurgerMenu.scss';

const BurgerMenu = (props) => {
	return (
		<div className="burgermenu" onClick={props.handleNavbar}>
			<div className={props.navbarState ? 'open' : ''}>
				<span>&nbsp;</span>
				<span>&nbsp;</span>
				<span>&nbsp;</span>
			</div>
		</div>
	);
};

export default BurgerMenu;
